import LandingpageHeader from './index'

export default { LandingpageHeader }
